<template>
  <span class="my-tag tr" :style="{'color': fontColor, 'borderColor': borderColor, 'backgroundColor': bgColor}">
    {{ name }}
  </span>
</template>

<script>
export default {
  props: {
    classType: {
      type: String,
      default: '',
    },
    name: null,
  },
  data() {
    return {
      fontColor: '',
      borderColor: '',
      bgColor: '',
    };
  },
  watch:{
    classType: {
      handler() {
        let colorArr = ['#515a6e', 'transparent', 'transparent'];
        if(this.classType && this.classType.includes('#')) {
          colorArr = this.classType.split(',');
        }
        this.fontColor = colorArr[0] || '#515a6e';
        this.borderColor = colorArr[1] || 'transparent';
        this.bgColor = colorArr[2] || 'transparent';
      },
      immediate: true
    }
  },
  methods: {
  },
};
</script>